module.exports = __webpack_public_path__ + "img/band-4.818e2c78.png";